import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import EngineSection from "@/components/sections/EngineSection";
import DestinationsSection from "@/components/sections/DestinationsSection";
import PopularDestinations from "@/components/sections/PopularDestinations";
import UnmissableOffersSection from "@/components/sections/UnmissableOffersSection";
import { useEffect, useState } from "react";
import sorteoImg from "@/assets/sorteo_01.jpg";
import HomePromoModal from "@/components/HomePromoModal";

const Index = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (typeof window !== "undefined") {
      setOpen(true);
    }
  }, []);

  return (
    <>
      <HomePromoModal
        open={false}
        onClose={() => setOpen(false)}
        image={sorteoImg}
      />
      <div className="min-h-screen flex flex-col">
        <Header />
        <main className="flex-1">
          <EngineSection />
          {/* <GoogleReviewsBadge /> */}
          {/* <ServicesSection /> */}
          <UnmissableOffersSection />
          <DestinationsSection />
          {/* <PackagesSection /> */}
          <PopularDestinations />
          {/* <LoyaltyBanner /> */}
          {/* <PromosSection /> */}
        </main>
        <Footer />
      </div>
    </>
    
  );
};

export default Index;